var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid"},[_c('div',{staticClass:"grid-item"},[_c('equip-list')],1),_c('div',{staticClass:"grid-item"},[_c('tower-crane-monitoring'),_c('v-gaps',{attrs:{"height":16}}),_c('crane-data')],1),_c('div',{staticClass:"grid-item"},[_c('history-warning-statistic'),_c('v-gaps',{attrs:{"height":16}}),_c('safty-warning')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }